import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class HospitalXService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }


  getCameraList(event?: any): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.camera.getCamerasList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction;
    return this.request.getApi(url);
  }


  getCameraListAll(): Observable<any> {


    let url = URLS.camera.getCameraListAll;
    return this.request.getApi(url);
  }

  saveCameras(values): Observable<any> {
    let url = URLS.camera.saveCameras;
    return this.request.postApi(url, values);
  }

  editCameras(id, values): Observable<any> {
    let url = URLS.camera.editDeleteCameras;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteCameras(id): Observable<any> {
    let url = URLS.camera.editDeleteCameras;
    url = _.replace(url, "{id}", id);
    return this.request.deleteApi(url);
  }

  getCamerasInfo(id): Observable<any> {
    let url = URLS.camera.editDeleteCameras;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  PatchCameras(data): Observable<any> {
    let url = URLS.camera.editDeleteCameras;
    url = _.replace(url, "{id}", data.camera_id);
    return this.request.patchApi(url, data);
  }

  getHospitalsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.hospital.getHospitalsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction;
    return this.request.getApi(url);
  }

  saveHospitals(values): Observable<any> {
    let url = URLS.hospital.saveHospitals;
    return this.request.postApi(url, values);
  }

  editHospitals(id, values): Observable<any> {
    let url = URLS.hospital.editDeleteHospitals;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteHospitals(data): Observable<any> {
    let url = URLS.hospital.editDeleteHospitals;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getHospitalsInfo(id): Observable<any> {
    let url = URLS.hospital.editDeleteHospitals;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


  getHospitalListAll(): Observable<any> {
    let url = URLS.hospital.getHospitalListAll;
    return this.request.getApi(url);
  }


  getHospitalGroupsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.hospital_groups.getHospitalGroupsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction;
    return this.request.getApi(url);
  }

  saveHospitalGroups(values): Observable<any> {
    let url = URLS.hospital_groups.saveHospitalGroups;
    return this.request.postApi(url, values);
  }

  editHospitalGroups(id, values): Observable<any> {
    let url = URLS.hospital_groups.editDeleteHospitalGroups;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteHospitalGroups(data): Observable<any> {
    let url = URLS.hospital_groups.editDeleteHospitalGroups;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getHospitalGroupsInfo(id): Observable<any> {
    let url = URLS.hospital_groups.editDeleteHospitalGroups;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


  PatchHospitalGroups(id, data): Observable<any> {
    let url = URLS.hospital_groups.editDeleteHospitalGroups;
    url = _.replace(url, "{id}", id);
    return this.request.patchApi(url, data);
  }

  getHospitalGroupsByFirst(): Observable<any> {
    let url = URLS.hospital_groups.getHospitalGroupsFirst + '?type=user';
    return this.request.getApi(url);
  }

  getHospitalGroupsListAll(): Observable<any> {
    let url = URLS.hospital_groups.getHospitalGroupsListAll;
    return this.request.getApi(url);
  }
}
